module.exports = __webpack_public_path__ + "img/concentration_2_selected.4cb11166.svg";